import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatDividerModule } from '@angular/material/divider'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'
import { HealthUnitService } from '../../../core/services/health-unit/location/health-unit.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {NgxMaskDirective} from 'ngx-mask';
import {MunicipalityService} from '../../../core/services/municipality/municipality/municipality.service';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {MessageService} from '../../../core/services/message/message/message.service';

@Component({
  selector: 'message-edit',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatDividerModule,
    MatSlideToggle,
    NgxMaskDirective,
    MatOption,
    MatSelect,
  ],
  templateUrl: './message-edit.component.html',
  styleUrl: './message-edit.component.scss',
  providers: [
    MessageService,
  ],
  standalone: true,
})
export class MessageEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private locationService: MessageService,
    private snackbar: SnackbarCustomService,
    private viaCepService: ViaCepService,
    private dialogRef: MatDialogRef<MessageEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = this.data.item
  }

  @Output() responseEdit = new EventEmitter()

  item: any = {}
  form: FormGroup = new FormGroup({})
  listUseTypes: any[] = []

  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
    this.useTypes()
  }
  useTypes(){
    this.locationService.useTypes().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listUseTypes = response.data
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.item.id,
      nome: this.form.get('name')?.value,
      texto: this.form.get('text')?.value,
      id_tipo_uso: this.form.get('useType')?.value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      name: [this.item.nome, [Validators.required]],
      useType: [this.item.id_tipo_uso, [Validators.required]],
      text: [this.item.texto, [Validators.required]],
    })
  }

  editLocation() {
    this.loading = true
    this.locationService.editMessage(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
}
